import React from "react";

const SkipUpIcon = () => (
	<g>
		<path d='M12.0001 13.9142L16.793 18.7071L18.2072 17.2929L12.0001 11.0858L5.79297 17.2929L7.20718 18.7071L12.0001 13.9142ZM6.00008 7L18.0001 7V9L6.00008 9L6.00008 7Z' />
	</g>
);

export default SkipUpIcon;
